
var idcardLen = 18;
var ratioValue = 11;
var ratio = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //身份证号码前17位数分别乘以不同的系数
var matchMap = {
    0: '1',
    1: '0',
    2: 'X',
    3: '9',
    4: '8',
    5: '7',
    6: '6',
    7: '5',
    8: '4',
    9: '3',
    10: '2'
}; //将这17位数字和系数相乘的结果相加,对11进行求余，得出身份证最后一个字符


function isString(idcard) {
    if(!idcard) {
        return false
    }
    return Object.prototype.toString.call(idcard) === '[object String]'
}

function isNumber(idcard) {
    if(!idcard) {
        return false
    }
    return Object.prototype.toString.call(idcard) === '[object Number]'
}

function leapYear(year) {
    if (year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)) {
      return true;
    } else {
      return false;
    }
}
function inRange(val, min, max) {
    if (val >= min && val <= max) {
      return true;
    }
    return false;
}

function verifyBirthday(birthday) {
    if(!birthday) {
        return false
    }
    //验证生日合法性
    if (!isString(birthday) || birthday.length !== 8) {
      return false;
    }
    var year = birthday.slice(0, 4),
      month = birthday.slice(4, 6),
      date = birthday.slice(6, 8);
    var flag = false;
    if (isNaN(Number(year)) || isNaN(Number(month)) || isNaN(Number(date))) {
      return false;
    }
    year = Number(year), month = Number(month), date = Number(date);
    if (year > new Date().getFullYear()) {
      return false;
    }
    var FebDay = 28;
    if (leapYear(year)) {
      FebDay = 29;
    }
    switch (month) {
      case 1:
      case 3:
      case 5:
      case 7:
      case 8:
      case 10:
      case 12:
        flag = inRange(date, 1, 31);
        break;
      case 2:
        flag = inRange(date, 1, FebDay);
        break;
      case 4:
      case 6:
      case 9:
      case 11:
        flag = inRange(date, 1, 30);
        break;
    }
    return flag;
}


function checkCard(idcard) {
    // 
    if(!idcard) {
        return false
    }

    // 

    // 

    return true
}


/**
 * 获取年龄
 * 
 * @param {身份证} idcard 
 * @returns 
 */
 export function idcardAge(idcard) {
    var birthday = idcard.slice(6, 14);
    var age;
    if (!(isString(birthday) || isNumber(birthday))) {
      return false;
    }
    if (!verifyBirthday(birthday)) {
        return false;
    }
    birthday = birthday.toString();
    var year = birthday.slice(0, 4);
    var month = birthday.slice(4, 6);
    var date = birthday.slice(6, 8);
    var curDate = new Date();
    try {
      if ((1 + curDate.getMonth() < parseInt(month)) || (1 + curDate.getMonth() === parseInt(month) && curDate.getDate() < parseInt(date))) {
        age = curDate.getFullYear() - parseInt(year) - 1;
      } else {
        age = curDate.getFullYear() - parseInt(year);
      }
    } catch (e) {
      age = 0;
    }
    return isNaN(age) ? 0 : age;
}


/**
 * 获取性别
 * 
 * @param {身份证} idcard 
 * @returns 
 */
 export function idcardSex(idcard) {
    if (!checkCard(idcard)) {
      return false;
    }
    var sexualChar = idcard.slice(idcard.length - 2, idcard.length - 1);
    if (isNaN(Number(sexualChar))) {
      return false;
    }
    if (Number(sexualChar) % 2 === 0) {
      return "女";
    }
    return "男";
}


/**
 * 获取生日
 * 
 * @param {身份证} idcard 
 * @returns  YYYY-MM-dd
 */
export function idcardBirthday(idcard) {
    if (!checkCard(idcard)) {
      return false;
    }
    var birthday = idcard.slice(6, 14);
    if (isNaN(Number(birthday))) {
      return false;
    }
    if (!verifyBirthday(birthday)) {
      return false;
    }

    let YYYY = birthday.slice(0,4)
    let MM = birthday.slice(4,6)
    let dd = birthday.slice(6)

    return `${YYYY}-${MM}-${dd}`;
}



/**
 * 验证
 * 
 * @param {身份证} idcard 
 * @returns 
 */
export function idcardVerify(idcard) {
    if (!isString(idcard)) {
      return false;
    }
    if (idcard.length !== idcardLen) {
      return false;
    }
    //验证生日合法性
    if (!verifyBirthday(idcard.slice(6, 14))) {
      return false;
    }
    var lastChar = idcard.slice(idcardLen - 1);
    var pre17Char = idcard.slice(0, idcardLen - 1);
    var charList = pre17Char.split('');
    var totleCount = 0;
    if (!/^(\d|X)$/.test(lastChar)) {
      return false;
    }
    for (var i = 0, len = charList.length; i < len; i++) {
      if (isNaN(Number(charList[i]))) {
        return false;
      }
      totleCount += Number(charList[i]) * ratio[i];
    }
    if (matchMap[totleCount % ratioValue] === lastChar) {
      return checkCard(idcard);
    } else {
      return false;
    }
}















